import React, {useEffect, ReactElement} from 'react';
import {useLazyGetStoreDetailsQuery} from '../../api/storesApi';
import {useStoreSlug} from '../../hooks';
import {StoreCreatedViaType} from '../../models/storeDetails';

const pushCommunityPlatformEvent = (communityType: string) => {
  window.dataLayer.push({
    event: 'community_platform',
    community_type: communityType
  });
};

const getCommunityType = (createdVia: StoreCreatedViaType) => {
  return createdVia === 'groups' ? 'gof' : 'store';
};

const GTMInitializer = (): ReactElement => {
  const storeSlug = useStoreSlug();
  const [triggerGetStoreDetailsQuery, {data: storeDetails}] =
    useLazyGetStoreDetailsQuery();

  useEffect(() => {
    if (storeSlug) triggerGetStoreDetailsQuery(storeSlug);
    else pushCommunityPlatformEvent('store');
  }, [storeSlug]);

  useEffect(() => {
    if (storeDetails)
      pushCommunityPlatformEvent(getCommunityType(storeDetails.createdVia));
  }, [storeDetails]);

  return <></>;
};

export default GTMInitializer;
